// src/components/common/color_pallate.jsx

export const COLORS = {
    // Primary Brand
    primary: "#304B82",

    // Accent
    accent: "#EFB851",

    // Main Background
    background: "#FBF7EC",

    // Cards / Sections
    surface: "#FFFDF8",

    // Main Text
    text: "#20252B",

    textLight: "#FFFFFF",

    // Secondary Accent
    secondary: "#A8B89A",

    // Border / UI (derived from secondary)
    border: "#A8B89A",

    // Muted Text (derived from main text with opacity)
    textMuted: "rgba(32, 37, 43, 0.6)",

    // Gradient (derived from primary and secondary)
    gradient: {
        from: "#304B82",
        to: "#A8B89A",
    },
};

export default COLORS;